var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		39933,
		9933
	],
	"./osmTagToNameMapping-cs.ts": [
		6497,
		6497
	],
	"./osmTagToNameMapping-de.template.ts": [
		76606,
		6606
	],
	"./osmTagToNameMapping-de.ts": [
		83052,
		3052
	],
	"./osmTagToNameMapping-en.ts": [
		81016,
		1016
	],
	"./osmTagToNameMapping-hu.template.ts": [
		67738,
		7738
	],
	"./osmTagToNameMapping-hu.ts": [
		80088,
		88
	],
	"./osmTagToNameMapping-it.template.ts": [
		30072,
		72
	],
	"./osmTagToNameMapping-it.ts": [
		6822,
		6822
	],
	"./osmTagToNameMapping-pl.template.ts": [
		29155,
		9155
	],
	"./osmTagToNameMapping-pl.ts": [
		1271,
		1271
	],
	"./osmTagToNameMapping-sk.template.ts": [
		12805,
		2805
	],
	"./osmTagToNameMapping-sk.ts": [
		7529,
		7529
	],
	"./osmTagToNameMapping-xx.template.ts": [
		17687,
		7687
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;